import { motion } from "framer-motion";
import { MaskedHeading } from "@/components/common/MaskedHeading";

// Compact hero for interior pages. Clipped image with charcoal overlay.
export const PageHero = ({ eyebrow, titleLines, lead, image, imageAlt }) => (
  <section className="relative isolate overflow-hidden bg-legacy-charcoal pt-32 pb-20 md:pt-44 md:pb-28">
    {image && (
      <>
        <div className="absolute inset-0 -z-10">
          <img
            src={image}
            alt={imageAlt || ""}
            className="h-full w-full object-cover opacity-30"
          />
        </div>
        <div className="absolute inset-0 -z-10 bg-gradient-to-r from-legacy-charcoal via-legacy-charcoal/85 to-legacy-charcoal/40" />
      </>
    )}
    <div className="absolute inset-0 -z-10 grain" aria-hidden="true" />
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      {eyebrow && (
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6 }}
          className="text-xs md:text-sm tracking-[0.25em] uppercase font-medium text-legacy-mint mb-5"
        >
          {eyebrow}
        </motion.p>
      )}
      <MaskedHeading
        lines={titleLines}
        className="font-heading text-5xl md:text-6xl lg:text-7xl text-white leading-[0.98] tracking-tight max-w-4xl"
      />
      {lead && (
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.4 }}
          className="mt-7 max-w-2xl text-lg md:text-xl text-white/70 leading-relaxed"
        >
          {lead}
        </motion.p>
      )}
    </div>
  </section>
);
